module.exports = __webpack_public_path__ + "img/2008-08_the-new-york-times-magazine.a8711e64.png";